<template>
  <v-card>
    <v-card-text>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">
          Transaction Configuration:
        </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2" md="3">
          <v-checkbox
            id="tmcWarSettingFundsOnly"
            class="tmc-war-setting input-text-size radio-and-checekbox-size "
            v-model="editItem.fundsOnly"
            label="Funds Only"

          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingMultipleFunds"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.multipleFunds"
            label="Multiple Funds per Warrant"
          ></v-checkbox>
        </v-col>
         <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingUsedLastRegisterDate"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.usedLastRegisterDate"
            label="Enable Last Used Register Date"
          ></v-checkbox>
        </v-col>
         <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingWarrentNumber"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.warrantNumber"
            label="Edit Warrant Number"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2" md="3">
          <v-checkbox
            id="tmcWarSettingFundsOnly"
            class="tmc-war-setting input-text-size radio-and-checekbox-size "
            v-model="editItem.multipleAppropriationEntry"
            label="Multiple Appropriation Entry"

          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingCombinedPaymentNumbers"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.combinedPaymentNumbers"
            label="Combined Payment Numbers for All Funds"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">
          Warrants Import / Export Configuration:
        </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" md="3">
          <v-checkbox
            id="tmcWarSettingCrossRefFund"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.crossRefFund"
            label="Check Cross reference Fund number"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingAllowImpWithErrInWarNoSeq"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.allowImpWithErrInWarNoSeq"
            label="Allow to proceed import with sequence error in Warrant number(s)"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingInsufficentFundsWarning"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.insufficentFundsWarning"
            label="Enable Insufficient Funds Warning"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
           class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.glReportUseRegisterDate"
            label="Use Register Date for GL Export"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingWarrantRegisterOnImport"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.isCreateWarRegisterOnImport"
            label="Create Warrant Register on import"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingClerkSystem"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.clerkSystem"
            label="Clerk System"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingEFTFlagWarrantImport"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.ignoreEFTFlagWarrantImport"
            label="Ignore EFT flag warrant import"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingEFTFlagWarrantImport"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.skipPrevRegWar"
            label="Skip previously registered warrants"
          ></v-checkbox>
        </v-col>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingAssignPaymentNumberToEftWarrants"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.assignPaymentNumberToEftWarrants"
            label="Assign Payment Number to EFT Warrants"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">
          Clearing Fund Configuration:
        </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" md="3">
          <v-checkbox
            id="tmcWarSettingClearingFund"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.clearingFund"
            label="Enable Clearing Fund Number"
          ></v-checkbox>
        </v-col>
        <v-col v-if="editItem.clearingFund"
          cols="8" md="4">
          <v-text-field
            :rules="clearingFundValidation"
            id="tmcWarSettingClearingFundList"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.clearingFundList"
            label="Clearing Funds"
            hint="Clearing Funds should be comma seperated"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size">
          Print Warrant Configuration:
        </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="4" md="3">
          <v-checkbox
            id="tmcWarSettingPrintWarrant"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.enablePrintWarrant"
            label="Enable Print Warrant"
          ></v-checkbox>
        </v-col>
        <v-col v-if="editItem.enablePrintWarrant"
          cols="8" md="3">
          <v-text-field
            id="tmcWarSettingPrintableFunds"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.fundListForPrintWarrant"
            label="Fund List for Print Warrant"
            hint="Funds should be comma seperated"
          ></v-text-field>
        </v-col>
        <v-col v-if="editItem.enablePrintWarrant"
          cols="4" md="3">
          <v-checkbox
            id="tmcWarSettingPrintRemarks"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.printRemarks"
            label="Print Remarks"
          ></v-checkbox>
        </v-col>
        <v-col v-if="editItem.enablePrintWarrant"
          cols="4" md="3">
          <v-checkbox
            id="tmcWarSettingPrintSignatureLine"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.signatureLine"
            label="Print 2 signature lines"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col v-if="editItem.enablePrintWarrant"
          cols="4" md="3">
          <v-checkbox
            id="tmcWarSettingHideMicrAcctLine"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.hideMicrAcctLine"
            label="Hide MICR/Acct line"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size ">
          Payroll Program Configuration:
        </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3" md="3">
          <v-checkbox
            id="tmcWarSettingPayrollRegisterProgram"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.payrollRegisterProgram"
            label="Enable Payroll Register Program"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
        <h3 class="text-decoration-underline input-text-size ">
          Report Configuration:
        </h3>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <v-checkbox
            id="tmcWarSettingShowCancelledNet"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            v-model="editItem.showCancelledNet"
            label="Warrant Register: show Canceled Warrants and Net Total lines"
          ></v-checkbox>
        </v-col>
      </v-row>
      <v-card-actions>
        <v-spacer></v-spacer>
          <v-btn
            id="WarSettingSaveBtn"
            class="tmc-war-setting input-text-size radio-and-checekbox-size"
            depressed
            color="primary"
            @click="update">
            Save
          </v-btn>
      </v-card-actions>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import { checkStringEmptiness } from '../../util/shared/vue-global';
import '../../assets/style.css';

export default {
  computed: {
    ...mapState({
      editItem: (state) => {
        const stateCopy = { ...state.SystemConfig.warSettingItem };
        return stateCopy;
      },
    }),
    clearingFundValidation() {
      return [
        (value) => /^(\d{4}\s*-\s*\d+)(,\s*\d{4}\s*-\s*\d+)*$/.test(value) || 'Invalid format (e.g. 1234-5678,)',
      ];
    },
  },
  created() {
    this.$store.dispatch(
      'SystemConfig/loadConfig',
      { requiredScope: 'warconfig' },
    );
  },
  methods: {
    savableEdits() {
      /* format clearing fund list */
      if (!checkStringEmptiness(this.editItem.clearingFundList)) {
        const allClearingFundNumbers = this.editItem.clearingFundList || '';
        const clearingFundNumbers = allClearingFundNumbers.toString().match(/[^,\s][^,]*/g).filter(Boolean);
        this.editItem.clearingFundList = clearingFundNumbers;
      }

      /* format fund list of print warrant */
      if (!checkStringEmptiness(this.editItem.fundListForPrintWarrant)) {
        const fundListForPrintWarrant = this.editItem.fundListForPrintWarrant || '';
        this.editItem.fundListForPrintWarrant = fundListForPrintWarrant.toString().match(/[^,\s][^,]*/g).filter(Boolean);
      }
    },
    buildWarConfigItem() {
      const settingItem = this.editItem;
      /* When you will update any new field in the war setting,
        you need to add the field here. */
      return {
        id: settingItem.id,
        fundsOnly: settingItem.fundsOnly,
        multipleFunds: settingItem.multipleFunds,
        usedLastRegisterDate: settingItem.usedLastRegisterDate,
        warrantNumber: settingItem.warrantNumber,
        multipleAppropriationEntry: settingItem.multipleAppropriationEntry,
        combinedPaymentNumbers: settingItem.combinedPaymentNumbers,
        crossRefFund: settingItem.crossRefFund,
        allowImpWithErrInWarNoSeq: settingItem.allowImpWithErrInWarNoSeq,
        insufficentFundsWarning: settingItem.insufficentFundsWarning,
        glReportUseRegisterDate: settingItem.glReportUseRegisterDate,
        isCreateWarRegisterOnImport: settingItem.isCreateWarRegisterOnImport,
        clerkSystem: settingItem.clerkSystem,
        ignoreEFTFlagWarrantImport: settingItem.ignoreEFTFlagWarrantImport,
        skipPrevRegWar: settingItem.skipPrevRegWar,
        assignPaymentNumberToEftWarrants: settingItem.assignPaymentNumberToEftWarrants,
        clearingFund: settingItem.clearingFund,
        clearingFundList: settingItem.clearingFundList,
        enablePrintWarrant: settingItem.enablePrintWarrant,
        fundListForPrintWarrant: settingItem.fundListForPrintWarrant,
        printRemarks: settingItem.printRemarks,
        signatureLine: settingItem.signatureLine,
        hideMicrAcctLine: settingItem.hideMicrAcctLine,
        payrollRegisterProgram: settingItem.payrollRegisterProgram,
        showCancelledNet: settingItem.showCancelledNet,
      };
    },
    update() {
      if (window.confirm('Are you sure want to update this configuration?')) {
        this.savableEdits();
        const payload = { calledScope: 'warconfig', item: this.buildWarConfigItem() };
        this.$store.dispatch('SystemConfig/updateConfig', payload);
      }
    },
  },
};
</script>
